import React, { useEffect } from 'react';

import { apiArchiveCampaign, apiDeleteCampaign } from 'src/api/campaignsSetup';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { MyCampaignsListItemType, MyCampaignUnArchiveType } from 'src/models/Campaigns/MyCampaigns';
import { DonationPageListItemType } from 'src/models/DonationPage/List';
import { dispatchAnyRequestStart } from 'src/store/anyRequest/helpers';
import { useAnyRequest } from 'src/utils/hooks/useAnyRequest';
import { useTHelper } from 'src/utils/i18n';
import { PromiseReturnType } from 'src/utils/types';

const uniqueId = 'campaignListArchiveCampaign';

type Props = {
  item: MyCampaignsListItemType | DonationPageListItemType | null;
  hideModal: () => void;
  archive: boolean;
  onSubmit: (ignorePageIndex?: boolean) => void;
};

export const MyCampaignsModalArchive: React.FC<Props> = ({ item, hideModal, archive, onSubmit }: Props) => {
  const tHelper = useTHelper(`myCampaigns.modals.${archive ? 'archive' : 'unarchive'}`);

  const { loading, response } = useAnyRequest<PromiseReturnType<typeof apiDeleteCampaign>>(uniqueId);

  useEffect(() => {
    if (response) {
      hideModal();
      onSubmit();
    }
  }, [hideModal, onSubmit, response]);

  const entitySingularLower = item?.ProjectTerminology.Singular.toLowerCase() || '';

  return (
    <UiModal
      header={tHelper('header', { entitySingularLower })}
      successLoading={loading}
      successBtnText={tHelper('successBtnText')}
      onSuccess={() => {
        if (item) {
          const data: MyCampaignUnArchiveType = { ID: item.ID, doArchive: archive };

          dispatchAnyRequestStart({
            data,
            apiFunction: apiArchiveCampaign,
            uniqueId,
          });
        }
      }}
      onHide={hideModal}
    >
      {tHelper('body', { entitySingularLower })}
    </UiModal>
  );
};
